module.exports = __webpack_public_path__ + "static/media/info-circle-outlined.8975b19a.svg";